import { packageTypeMap } from 'stores/multi-item-store';

import { MultiItemContext, ShoppingContext } from 'models/multi-item/multi-item-types';

import { PackageType } from '__generated__/api';

function mapMultiItem(multiItemContext?: { id: string; packageType: PackageType }): MultiItemContext | null {
  if (!multiItemContext) {
    return null;
  }

  return {
    id: multiItemContext.id,
    packageType: packageTypeMap[multiItemContext.packageType],
  };
}

export const adaptShoppingContext = (multiItemContext?: { id: string; packageType: PackageType }): ShoppingContext | null => ({
  multiItem: mapMultiItem(multiItemContext),
});
